import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    deleteRecordSuccess,
    deleteRecord,
    deleteRecordFailure,
} from './member-attachment.action';

import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecordsSuccess as fetchRecordsSuccessClub } from '../Clubs/clubs.action';
import { FileUploadService } from 'src/app/core/services/file-upload.service';
import { HelperService } from 'src/app/core/services/helper.service';


@Injectable()
export class MemberAttachmentRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'member/'+data.memberId+'/member-attachments';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        const total = data.total;

                        this.alertService.triggerAlert(response.message, "success");
                        // this.store.dispatch(fetchRecordsSuccessClub({ listData: data.club, total: 0, isVatValid: false }));
                        return fetchRecordsSuccess({ listData: data.records, total: total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                
                const url = 'member/'+data.memberId+'/member-attachments/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        
                        this.uploader.uploadQueue = this.uploader.uploadQueue.filter(f => f.isUploading && !f.isUploaded && !f.isCancelled);
                        this.store.dispatch(fetchRecords({memberId: data.memberId}));
                        this.alertService.triggerAlert(response.message, "success");
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private uploader: FileUploadService,
        public helperService: HelperService
    ) { }

}